export default __webpack_public_path__ + "static/media/columnVisibility.8d2c14bd.svg";